import { Api } from '../baseApi';

interface ILookupResponse {
  'LookupType'?: 'Fixed' | 'Dynamic';
  'ValueType'?: 'Int32' | 'String' | 'Decimal';
  'Data'?: ILookupOption[];
  'Scope'?: string;
}

export interface ILookupOption {
  'Code'?: string;
  'Display'?: string;
  'Label'?: string;
  'Description'?: string;
  'Details'?: {
    [key: string]: any;
  };
}

interface IQuery {
  SearchText: string;
  lookupName: string;
  BatchPage: number;
  BatchSize: number;
}

export const fetchLookupData = (query: IQuery) => {
  const { lookupName, ...restQuery } = query;

  return Api.post<{ SearchText: string; BatchPage: number; BatchSize: number }, ILookupResponse>(`CustomTypes/Lookup/${lookupName}/Search`, restQuery)
    .then((response) => {
      return response.Data;
    });
};

export async function fetchPurchaseOrders(ProductId: number, SupplierId: number, Warehouse: string, BatchPage?: number, BatchSize?: number): Promise<any> {
  return Api.get(`Product/${ProductId}/Warehouse/${Warehouse}/Supplier/${SupplierId}/PurchaseOrderLines?BatchPage=${BatchPage}&BatchSize=${BatchSize}&responseMetadataFormat=None`
  );
}
export const fetchLookupOption = (query: { lookupName?: string; value: string }) => {
  const { lookupName, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Lookup/${lookupName}/Option/${value}`);
};
export const fetchCustomerSupplierLookupOption = (query: { lookupName?: string; value: unknown; CustomerId: number; Supplier: number }) => {
  const { lookupName, CustomerId, Supplier, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Customer/${CustomerId || 0}/Supplier/${Supplier || 0}/Lookup/${lookupName}/Option/${value}`);
};
export const fetchCustomerLookupOption = (query: { lookupName?: string; value: unknown; CustomerId: number }) => {
  const { lookupName, CustomerId, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Customer/${CustomerId}/Lookup/${lookupName}/Option/${value}`);
};
export const fetchWorkSaleLookupOption = (query: { lookupName?: string; value: unknown; WorksaleId: string }) => {
  const { lookupName, WorksaleId, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Worksale/${WorksaleId}/Lookup/${lookupName}/Option/${value}`);
};
export const fetchProductLookupOption = (query: { lookupName?: string; value: unknown; ProductId: string }) => {
  const { lookupName, ProductId, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Product/${ProductId}/Lookup/${lookupName}/Option/${value}`);
};
export const fetchEntityLookupOption = (query: { lookupName?: string; value: unknown; SalesEntity: string }) => {
  const { lookupName, SalesEntity, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/SalesEntity/${SalesEntity}/Lookup/${lookupName}/Option/${value}`);
};
export const fetchPurchaseOrderLookupOption = (query: { lookupName?: string; value: unknown; Supplier: string }) => {
  const { lookupName, Supplier, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Supplier/${Supplier}/Lookup/${lookupName}/Option/${value}`);
};
export const fetchWarehousePurchaseOrderLookupOption = (query: { lookupName?: string; value: unknown; Supplier: string; Warehouse: string }) => {
  const { lookupName, Warehouse, Supplier, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Warehouse/${Warehouse}/Supplier/${Supplier}/Lookup/${lookupName}/Option/${value}`);
};

export const fetchWarehouseProductLookupOption = (query: { lookupName?: string; value: unknown; Product: string; Warehouse: string }) => {
  const { lookupName, Warehouse, Product, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Warehouse/${Warehouse}/Product/${Product}/Lookup/${lookupName}/Option/${value}`);
};

export const fetchProductPurchaseOrderLookupOption = (query: { lookupName?: string; value: unknown; Supplier: string | number; ProductId: number; Warehouse: string }) => {
  const { lookupName, Supplier, ProductId, Warehouse, value } = query;

  return Api.get<ILookupOption>(`CustomTypes/Product/${ProductId}/Warehouse/${Warehouse}/Supplier/${Supplier}/Lookup/${lookupName}/Option/${value}`);
};
